module.exports = __webpack_public_path__ + "ed6220eae8acae944f14ede4b1e3e86e.pdf";